import { useSpring, animated } from '@react-spring/web'
import { Icon } from '@iconify/react'
import { createPortal } from 'react-dom'
import { Button } from './legacy'

export default function CornerConfirmModal({
  onClose,
  className = '',
  title = 'Bạn có chắc chắn xử lý yêu cầu không?',
  content = 'Thao tác này không thể hoàn tác!',
  onSubmit,
  cancelText = 'Hủy',
  confirmText = 'Xác nhận',
  isLoading = false,
  icon = 'ph:warning-bold',
  iconColor = 'text-warning',
  titleColor = 'text-warning',
  confirmButtonVariant = 'warning',
}) {
  const fadeStyle = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: { duration: 300 },
  })

  return createPortal(
    <animated.div
      style={fadeStyle}
      className="fixed inset-0 z-[50] flex items-center justify-center bg-black bg-opacity-30 p-3"
      onClick={() => {
        if (!isLoading) {
          onClose()
        }
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`absolute bottom-4 right-4 w-[300px] max-w-md rounded-lg bg-white p-6 shadow-xl ${className}`}
      >
        <div className="mb-4 flex flex-col items-center">
          <Icon icon={icon} className={`mr-3 text-7xl ${iconColor}`} />
          <h3 className={`mt-3 text-lg font-bold ${titleColor}`}>{title}</h3>
        </div>

        <p className="mb-6">{content}</p>

        <div className="space-y-2">
          <Button
            variant={confirmButtonVariant}
            fullWidth
            onClickHandler={() => {
              onSubmit && onSubmit()
              onClose()
            }}
            disabled={isLoading}
          >
            {confirmText}
          </Button>
          <Button
            variant="inline"
            onClickHandler={onClose}
            disabled={isLoading}
            fullWidth
          >
            {cancelText}
          </Button>
        </div>
      </div>
    </animated.div>,
    document.getElementById('modal')
  )
}
